module.exports = __webpack_public_path__ + "static/img/zy_doctor_app_code.12d020f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zy_doctor_app_code.png
// module id = ltWQ
// module chunks = 15